import type { UserFunctionsQuery } from "@/graphql";

export function toUserFunctionSelectValue(userFunctionId: number) {
  return -Math.abs(userFunctionId);
}

export function fromUserFunctionSelectValue(value: number) {
  return value < 0 ? Math.abs(value) : undefined;
}

export function getUserFunctionAssignment(
  userFunction: UserFunctionsQuery["UserFunctions"][number],
  siteId?: number,
) {
  return (
    userFunction.Assignments.find((assignment) => assignment.siteId === siteId) ??
    userFunction.Assignments.find((assignment) => assignment.siteId == null)
  );
}
